(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  exports.Contracts_Edit_Select_Handler = (function(superClass) {
    extend(Contracts_Edit_Select_Handler, superClass);

    function Contracts_Edit_Select_Handler() {
      return Contracts_Edit_Select_Handler.__super__.constructor.apply(this, arguments);
    }

    Contracts_Edit_Select_Handler.prototype.init = function() {
      this.layoutUrl = 'backend/portal/contracts/load-layout-add-select';
      this.layoutSelector = App.sidebar.contentDiv().find('#edit');
      this.subHandlers = {
        'ContractDelete': {
          'class': 'portal::handlers/contracts/Contracts_Delete_Dialog_Handler'
        }
      };
      return this.loadLayout();
    };

    Contracts_Edit_Select_Handler.prototype.afterLoadLayout = function() {
      var ths;
      ths = this;
      $('#contract_number').mask('99 - 9999 - 99', {
        placeholder: ' '
      });
      $('#contract_btn_back').bind('click', (function(_this) {
        return function() {
          _this.parent.dlg_handler.refresh();
          return _this.parent.unloadContract();
        };
      })(this));
      $('#contract_btn_delete').bind('click', (function(_this) {
        return function() {
          var handler;
          handler = _this.createSubHandler('ContractDelete');
          if (handler) {
            handler.loadLayoutPostOptions = {
              contract_id: $('#contract_id').val()
            };
            return handler.init();
          }
        };
      })(this));
      this.parent.dlg_handler.loadFields();
      return this.parent.makeValidation('Saving Contract');
    };

    return Contracts_Edit_Select_Handler;

  })(Handler);

}).call(this);
